import { css } from '@linaria/core';

export const styledButton = css`
	--button-color-primary: transparent;
	--button-color-secondary: var(--color-grey-95-solid);
	--button-color-additional: var(--color-white-m);
	border-width: 1px;
	border-style: solid;
	--additional-padding-x: 1px;

	&:hover:not(.disabled, :focus, .selected),
	&.checkbox-button:hover:not(.disabled, .selected) {
		--button-color-additional: transparent;
		--button-color-primary: var(--color-white-xs);
		--button-color-secondary: var(--color-grey-95-solid);
	}

	&:focus:not(:active, .selected, .checkbox-button) {
		--button-color-additional: var(--color-white-solid);
		--button-color-secondary: var(--color-white-solid);
		border-width: 2px;
		--additional-padding-x: 0px;
	}

	&:active:not(.selected) {
		--button-color-additional: transparent;
		--button-color-primary: var(--color-grey-44-solid);
		--button-color-secondary: var(--color-grey-95-solid);
	}

	&.disabled:not(.selected) {
		--button-color-secondary: var(--color-grey-52-solid);
		--button-color-primary: var(--color-grey-6-solid);
	}

	&.icon.disabled:not(.selected) {
		--button-color-primary: var(--color-white-xs);
		--button-color-secondary: var(--color-grey-52-solid);
	}

	&.selected {
		--button-color-primary: var(--color-grey-10-solid);
		--button-color-secondary: var(--color-grey-95-solid);
		--button-color-additional: var(--color-grey-95-solid);
	}
`;
